import React, { useEffect, useState } from 'react'
import { useError } from '../../../../components/contexts/ErrorContext';
import axiosClient from '../../../../components/api/axiosClient';
import AddTicketComponent from '../../../../components/AddTicketComponent';
import { format, addDays } from "date-fns";
import { fr } from "date-fns/locale";
import { isBefore } from "date-fns";
import { useNavigate } from 'react-router-dom';

export default function FormDatasEdit({ datasEvents, datasPass, refresh }) {

    const { handleError } = useError();
    // A propos de la catégorie
    const [categories, setCategories] = useState([]);
    const [error, setError] = useState({}); // Nouvel état pour gérer les erreurs
    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [eventTypes, setEventTypes] = useState({ vedette: false, populaire: false });
    const [addModal, setShowAddModal] = useState(false);
    const handleOnAddModalClose = () => setShowAddModal(false);
    const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
    const [showComments, setShowComments] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewOtherImage, setPreviewOtherImage] = useState(null);
    const navigate = useNavigate(); // Hook pour la redirection
    const [formData, setFormData] = useState({
        titre: datasEvents.titre || '',
        acteur_principal: datasEvents.acteur_principal || '',
        categorie: datasEvents.categorie || '',
        date_debut: datasEvents.date_debut || '',
        date_fin: datasEvents.date_fin || '',
        heure_debut: datasEvents.heure_debut || '',
        lieu: datasEvents.lieu || '',
        lien_gps: datasEvents.lien_gps || '',
        type_evenement: {
          populaire: eventTypes.populaire,
          vedette: eventTypes.vedette,
        },
        affiche: previewImage || null,
        image_lieu_evenement: previewOtherImage || null,
        description: datasEvents.description || '',
        date_fin_cloture: datasEvents.date_cloture || '',
        heure_fin_cloture: datasEvents.heure_cloture || '',
        
    });

    const [ticketsData, setTicketsData] = useState(() => 
        datasPass.length > 0 
            ? datasPass.map(ticket => ({
                id: ticket.id || "",
                nom: ticket.type || "",
                prix_unitaire: ticket.prix_unitaire || "",
                quantite: ticket.quantity || "",
                comment: ticket.comment || "",
            }))
            : [{
                id: null,
                nom: "",
                prix_unitaire: "",
                quantite: "",
                comment: "",
            }]
    );

    // Fonction pour parser `type_evenement`
    const parseTypeEvenement = (typeEvenement) => {
        return typeEvenement
            ? typeEvenement.split(";").reduce((acc, pair) => {
                const [key, value] = pair.split(":").map((item) => item.trim());
                acc[key] = value === "true";
                return acc;
            }, {})
            : { vedette: false, populaire: false };
    };
    
    const handleTicketsDataChange = (e, index) => {

        const { name, value } = e.target;

        setTicketsData((prevData) => {
            const updatedTickets = [...prevData];
            updatedTickets[index] = { 
                ...updatedTickets[index], 
                [name]: value 
            };
            return updatedTickets;
        });
    };

    const handleEventDataChange = (e) => {
        const { name, type, value, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,

            categorie: prev.categorie === "__Choisir une catégorie__" && name === "autre_categorie" 
            ? value 
            : name === "categorie" 
                ? value 
                : prev.categorie,
        }));
    };

    const base64ToFile = (base64String, fileName) => {
        let arr = base64String.split(",");
        let mime = arr[0].match(/:(.*?);/)[1]; // Récupère le type MIME
        let bstr = atob(arr[1]); // Décode la partie Base64
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
    
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
    
        return new File([u8arr], fileName, { type: mime });
    };
    

    useEffect(() => {
        if (datasEvents.affiche) {
            const file = base64ToFile(`data:image/jpeg;base64,${datasEvents.affiche}`, "affiche.jpg");
            setFormData((prev) => ({
                ...prev,
                affiche: file,
            }));
            setPreviewImage(URL.createObjectURL(file)); // Prévisualisation
        }
    
        if (datasEvents.image_lieu_evenement) {
            const file = base64ToFile(`data:image/jpeg;base64,${datasEvents.image_lieu_evenement}`, "lieu.jpg");
            setFormData((prev) => ({
                ...prev,
                image_lieu_evenement: file,
            }));
            setPreviewOtherImage(URL.createObjectURL(file));
        }
    }, [datasEvents]);
    

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
    
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (type === "affiche") {
                    setPreviewImage(reader.result);
                } else if (type === "image_lieu_evenement") {
                    setPreviewOtherImage(reader.result);
                }
            };
            reader.readAsDataURL(file);
    
            setFormData((prev) => ({
                ...prev,
                [type]: file,
            }));
        }
    };
    

    const validateForm = async () => {
        const newErrors = {};

        // Validation du champ titre
        if (!formData.titre.trim()) {
            newErrors.titre = "Le titre est requis";
        }

        // Validation du champ acteur_principal
        if (!formData.acteur_principal.trim()) {
            newErrors.acteur_principal = "Veuillez renseigner un acteur";
        }

        // Validation du champ catégorie
        if (!formData.categorie.trim()) {
            newErrors.categorie = "La catégorie est requise";
        }

        // Si la catégorie sélectionnée est '__Choisir une catégorie__', vérifiez si l'utilisateur a spécifié une autre catégorie
        if (
            !formData.categorie.trim() || formData.categorie === "__Choisir une catégorie__"
        ) {
            newErrors.categorie =
                "Veuillez choisir une catégorie ou en saisir une.";
        }

        const today = new Date();
        const minDate = addDays(today, 2);

        // Validation du champ date-debut
        if (!formData.date_debut) {
            newErrors.date_debut = "Veuillez renseigner ce champ";
        } else {
            const selectedDate = new Date(formData.date_debut);

            if (isBefore(selectedDate, minDate)) {
                newErrors.date_debut =
                    "La date de début doit être au moins 3 jours après la date actuelle";
            }
        }
        if (formData.date_fin) {
            if (isBefore(new Date(formData.date_fin), minDate)) {
                newErrors.date_fin =
                    "La date de fin n'est pas valide";
            }
        }

        // Validation du champ date-debut
        if (!formData.heure_debut) {
            newErrors.heure_debut = "Veuillez définir l'heure";
        }

        // Validation du champ date-debut
        if (!formData.lieu.trim()) {
            newErrors.lieu = "Veuillez définir le lieu";
        }

        // Validation du champ date-debut
        if (!formData.description.trim()) {
            newErrors.description = "Ce champ description est requis";
        }

        if (!formData.date_fin_cloture) {
            newErrors.date_fin_cloture = "Veuillez renseigner ce champ";
        } else if (isBefore(new Date(formData.date_fin_cloture), minDate)) {
            newErrors.date_fin_cloture =
                "Veuillez selectionner une date de cloture des ventes valide.";
        }

        // Validation du champ date-debut
        if (!formData.heure_fin_cloture) {
            newErrors.heure_fin_cloture = "Veuillez définir l'heure";
        }

        // Validation du champ affiche (image de l'événement)
        if (!formData.affiche) {
            newErrors.affiche = "Veuillez sélectionner une image de votre événement";
        } else {
            // Vérification du type et de la taille de l'image
            const maxSize = 2 * 1024 * 1024; // 2 Mo
            const selectedFile = formData.affiche;
            const allowedType = ['image/jpeg', 'image/png'];

            if (selectedFile.size > maxSize) {
                newErrors.affiche =
                    "Le fichier doit être une image et ne doit pas dépasser 2 Mo";
            }
            else if (!allowedType.includes(selectedFile.type)) {
                newErrors.affiche = "Format de fichier non supporté. Seuls JPG, PNG sont autorisés.";
            }
        }

        // Validation du champ image_lieu_evenement
        if (formData.image_lieu_evenement) {
            const allowedType = ['image/jpeg', 'image/png'];
            const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB

            const selectedFileDefault = formData.image_lieu_evenement;

            if (selectedFileDefault.size > maxSizeInBytes) {
                newErrors.image_lieu_evenement = "La taille de l'image et ne doit pas dépasser 2 Mo";
            }
            else if (!allowedType.includes(selectedFileDefault.type)) {
                newErrors.image_lieu_evenement = "Format de fichier non supporté. Seuls JPG, PNG sont autorisés.";
            }
        }

        ticketsData.forEach((ticket, index) => {
            if (!ticket.nom.trim()) {
                newErrors[`nom${index}`] = "Ce champ est requis";
            } else if (!/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\s'-]+$/.test(ticket.nom)) {
                newErrors[`nom${index}`] = "Le nom ne doit pas contenir de caractères spéciaux.";
            }

            const prixTicket = parseInt(ticket.prix_unitaire, 10);
            if (!ticket.prix_unitaire /* .trim() */) {
                newErrors[`prix_unitaire${index}`] = "Ce champ est requis";
            } else if (!/^\d+$/.test(ticket.prix_unitaire)) {
                newErrors[`prix_unitaire${index}`] = "Veuillez entrer un prix valide.";
            } else if (prixTicket < 500) {
                newErrors[`prix_unitaire${index}`] = "Le prix doit être supérieur ou égal à 500 XOF.";
            }

            const quantiteNum = parseInt(ticket.quantite, 10);
            if (!ticket.quantite /* .trim() */) {
                newErrors[`quantite${index}`] = "Ce champ est requis";
            } else if (!/^\d+$/.test(ticket.quantite)) {
                newErrors[`quantite${index}`] = "Veuillez entrer une quantité valide.";
            } else if (quantiteNum < 15) {
                newErrors[`quantite${index}`] = "La quantité doit être d'au moins 15.";
            }

            if (showComments[index]) {
                if (!ticket.comment || ticket.comment.trim() === "") {
                    newErrors[`comment${index}`] = "Ce champ est requis";
                } else if (ticket.comment.length > 500) {
                    newErrors[`comment${index}`] = "Le commentaire ne doit pas dépasser 500 caractères.";
                }
            }
        });

        setError(newErrors);

        // Si des erreurs sont présentes, le formulaire n'est pas valide
        return Object.keys(newErrors).length === 0;;
    };

    // Fonction pour soumettre le formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateForm();

        
        if (validationErrors) {

            // Fusionner formData et tickets
            const formDatas = {
                ...formData,
                ticketsData: ticketsData, // Ajout des tickets à l'objet formData
            };

            // Soumission des données ou logique d'inscription
            setLoading(true); // Activer le chargement

            axiosClient.post(`/request/user/event/validation/console/update/e/${datasEvents.id}`, formDatas)
            .then(
                ({data}) => {
                    
                    setSuccessMessage(data.messages);
                    setLoading(false);
                    
                    if (data.submited && data.status === 200) {
                        
                        setTimeout(() => {
                            // 🔄 Redirection vers "/success" après soumission réussie
                            navigate(`/dashboard/events/validations/show/info-e/${datasEvents.id}`);
                        }, 4000);
                    }

            }).catch(err => {
                const response = err.response;
                if (response) {
                    // console.log("Erreur de l'API :", response);
                    if (response.status === 422) {
                        setValidationError("Erreur ! Veuillez vérifier vos informations puis réessayer s'il vous plait !");
                    }else if (response.status === 500) {
                        if (response.data.errors) {
                            // Erreurs spécifiques aux champs
                            setError(response.data.errors);
                        }
                        if (response.data.message) {
                            // Erreur générale
                            setValidationError(response.data.message);
                        }
                    }
                    setLoading(false);
                    setTimeout(() => setValidationError(""), 7000);
                } else {
                    setValidationError("Erreur lors de la mise à jour de la demande événementielle.");
                    setLoading(false);
                    setTimeout(() => setValidationError(""), 7000);
                }
            })
        }
    };

    const CategoriesRequest = async () => {
        await axiosClient
            .get("/categories")
            .then((response) => setCategories(response.data))
            .catch((error) =>
                // console.error("Erreur lors de la récupération des catégories", error);
                handleError("Erreur lors de la récupération des catégories")
            );
    };

    useEffect(() => {
        CategoriesRequest();
    }, []);

    useEffect(() => {
        if (datasEvents?.type_evenement) {
            setEventTypes(parseTypeEvenement(datasEvents.type_evenement));
        }
    }, [datasEvents]);

    useEffect(() => {
        setFormData(prevData => ({
            ...prevData,
            type_evenement: {
                populaire: eventTypes.populaire,
                vedette: eventTypes.vedette,
            }
        }));
    }, [eventTypes]);    

    const addNewTicket = (e) => {

        e.preventDefault();

        // Vérifie le nombre actuel de tickets valides
        const validTicketsCount = ticketsData.filter(
            (ticket) => ticket.nom && ticket.prix_unitaire && ticket.quantite && ticket.comment
        ).length;

        if (validTicketsCount >= 5) {
            setIsAddButtonDisabled(true); // Désactive le bouton
            return; // Empêche l'ouverture du modal
        }

        // Permet l'ajout d'un nouveau ticket
        setShowAddModal(true);
    };

    const removeTicket = (index) => {

        const updatedTickets = ticketsData.filter((_, i) => i !== index);

        setTicketsData(updatedTickets);

        // Réévaluez si le bouton doit être réactivé
        if (updatedTickets.length < 5) {
            setIsAddButtonDisabled(false);
        }
    };

    const handleConfirmAddTicket = () => {
        setShowAddModal(false);
    };
    
    const toggleCommentField = (index) => {
        setShowComments((prevShowComments) => {
            const updated = [...prevShowComments];
            updated[index] = !updated[index];
    
            // Si on masque le champ de commentaire, réinitialiser le contenu
            if (!updated[index]) {
                setTicketsData((prevTicketsData) => {
                    const updatedTickets = [...prevTicketsData];
                    updatedTickets[index] = {
                        ...updatedTickets[index],
                        comment: "", // Réinitialise le champ comment
                    };
                    return updatedTickets;
                });

                setError((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[`comment${index}`]; // Supprime l'erreur associée
                    return updatedErrors;
                });
            }
    
            return updated;
        });
    };

    const isSubmitDisabled = () => {
        return loading;
    }

    return (
        <div>
            <div className='relative flex justify-center -top-32'>

                {validationError && (
                    <div className="text-sm fixed z-10 cf8dr cb8zv cvkq6 clbq0 cuvgf">
                        <div className="flex cm3rx ce4zk c6btv">
                            <div className="flex">
                                <svg
                                    className="cbm9w czr3n cq1qg coqgc chfzq"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z" />
                                </svg>
                                <div>{validationError}</div>
                            </div>
                        </div>
                    </div>
                )}

                {successMessage && (
                    <div className="text-sm fixed z-10 cf8dr cje53 cb8zv clbq0 cuvgf">
                        <div className="flex cm3rx ce4zk c6btv">
                            <div className="flex">
                            <svg
                                className="c612e cbm9w cq1qg coqgc chfzq"
                                width={16}
                                height={16}
                                viewBox="0 0 16 16"
                            >
                                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z" />
                            </svg>
                            <div>
                            {successMessage}
                            </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <h2 className="text-gray-800 dark:text-gray-100 font-bold cbtcb mb-2">
                Détails de la demande
            </h2>
            
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 mb-6" />
            <div className="sm:grid-cols-2 coah6 c4sak">
            
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="title">
                        Titre <span className="czr3n">*</span>
                    </label>
                    <input
                        id="title"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="text"
                        required
                        name='titre'
                        value={formData.titre}
                        onChange={handleEventDataChange}
                        placeholder='(ex): Grand concert du moment'
                    />
                    {error.titre && (
                        <small className="text-red-600 mt-2">
                            {error.titre}
                        </small>
                    )}
                </div>
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="actor">
                    Acteur principal <span className="czr3n">*</span>
                    </label>
                    <input
                        id="actor"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="text"
                        required
                        value={formData.acteur_principal}
                        name='acteur_principal'
                        onChange={handleEventDataChange}
                        placeholder='(ex): Grand concert du moment'
                    />
                    {error.acteur_principal && (
                        <small className="text-red-600 mt-2">
                            {error.acteur_principal}
                        </small>
                    )}
                </div>
                <div>
                    <label className="block text-sm c1k3n cu6vl">
                    Catégorie <span className="czr3n">*</span>
                    </label>
                    <select
                            name="categorie"
                            value={formData.categorie}
                            onChange={handleEventDataChange}
                            required
                            className="nc-Select caqf9 w-full block text-sm rounded-lg border-neutral-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900"
                        >
                            <option defaultChecked>
                                __Choisir une catégorie__
                            </option>
                            {categories.map((category, index) => (
                                <option key={index} value={category.name}>{category.name}</option>
                            ))}
                        </select>
                </div>
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="other_cat">
                    Autre Catégorie
                    </label>
                    <input
                        id="other_cat"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="text"
                        placeholder='Spécifier la catégorie'
                        name='categorie'
                        onChange={handleEventDataChange}
                    />
                </div>
            </div>
            {error.categorie && (
                <small className="text-red-600 mt-2">
                    {error.categorie}
                </small>
            )}

            <div className="sm:grid-cols-3 my-6 coah6 c4sak">
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="start_date">
                    Date de Début <span className="czr3n">*</span>
                    </label>
                    <input
                        id="start_date"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="date"
                        required
                        value={formData.date_debut}
                        name='date_debut'
                        onChange={handleEventDataChange}
                        min={format(addDays(new Date(), 3), "yyyy-MM-dd", {
                            locale: fr,
                        })}
                    />
                    {error.date_debut && (
                        <small className="text-red-600 mt-2">
                            {error.date_debut}
                        </small>
                    )}
                </div>
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="end_date">
                    Date de Fin
                    </label>
                    <input
                        id="end_date"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="date"
                        value={formData.date_fin}
                        name='date_fin'
                        onChange={handleEventDataChange}
                        min={format(addDays(new Date(), 3), "yyyy-MM-dd", {
                            locale: fr,
                        })}
                    />
                    {error.date_fin && (
                        <small className="text-red-600 mt-2">
                            {error.date_fin}
                        </small>
                    )}
                </div>
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="hour">
                    Heure <span className="czr3n">*</span>
                    </label>
                    <input
                        id="hour"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="time"
                        required
                        value={formData.heure_debut}
                        name='heure_debut'
                        onChange={handleEventDataChange}
                    />
                    {error.heure_debut && (
                        <small className="text-red-600 mt-2">
                            {error.heure_debut}
                        </small>
                    )}
                </div>
            </div>
            
            <div className="sm:grid-cols-2 my-6 coah6 c4sak">
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="place">
                    Lieu de l'evenement <span className="czr3n">*</span>
                    </label>
                    <input
                        id="place"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="text"
                        required
                        value={formData.lieu}
                        name='lieu'
                        onChange={handleEventDataChange}
                        placeholder='(ex): Palais de la culture'
                    />
                    {error.lieu && (
                        <small className="text-red-600 mt-2">
                            {error.lieu}
                        </small>
                    )}
                </div>
                <div>
                    <label className="block text-sm c1k3n cu6vl" htmlFor="link_place">
                    Lien GPS du lieu
                    </label>
                    <input
                        id="link_place"
                        className="c071z focus:ring-0 caqf9 w-full"
                        type="text"
                        required
                        value={formData.lien_gps}
                        name='lien_gps'
                        onChange={handleEventDataChange}
                        placeholder='Coller un lien Google Map du lieu'
                    />
                    {error.lien_gps && (
                        <small className="text-red-600 mt-2">
                            {error.lien_gps}
                        </small>
                    )}
                </div>
            </div>

            <div className='my-6 coah6 c4sak'>
                <div>
                    <h4 className="text-gray-800 dark:text-gray-100 font-semibold mb-2">
                    Types d'evenement
                    </h4>
                    <div className="flex flex-wrap items-center c9uh3">
                        <div className="cm0ci">
                        {/* Start */}
                        <label className="flex items-center">
                            <input 
                                type="checkbox" 
                                className="crgcy !text-primary-500 !focus:border-none focus:ring-[none] h-5 w-5" 
                                name="vedette"
                                checked={eventTypes.vedette}
                                onChange={(e) => setEventTypes({ ...eventTypes, vedette: e.target.checked })}
                            />
                            <span className="text-sm c8bkw">{"VEDETTE"}</span>
                        </label>
                        {/* End */}
                        </div>
                        <div className="cm0ci">
                        {/* Start */}
                        <label className="flex items-center">
                            <input 
                                type="checkbox" 
                                className="crgcy !text-primary-500 !focus:border-none focus:ring-[none] h-5 w-5" 
                                name="populaire"
                                checked={eventTypes.populaire}
                                onChange={(e) => setEventTypes({ ...eventTypes, populaire: e.target.checked })}
                            />
                            <span className="text-sm c8bkw">{"POPULAIRE"}</span>
                        </label>
                        {/* End */}
                        </div>
                    </div>
                </div>

            </div>

            <div className='mt-8 mb-6'>
                <h4 className="text-gray-800 dark:text-gray-100 font-semibold mb-2">
                    Date de Clôture des Ventes
                </h4>
                <div className='sm:grid-cols-2 coah6 c4sak'>
                    
                    <div>
                        <label className="block text-sm c1k3n cu6vl" htmlFor="sale_end_date">
                        Date <span className="czr3n">*</span>
                        </label>
                        <input
                            id="sale_end_date"
                            className="c071z focus:ring-0 caqf9 w-full"
                            type="date"
                            required
                            value={formData.date_fin_cloture}
                            name='date_fin_cloture'
                            onChange={handleEventDataChange}
                            min={format(addDays(new Date(), 3), "yyyy-MM-dd", {
                                locale: fr,
                            })}
                        />
                        {error.date_fin_cloture && (
                            <small className="text-red-600 mt-2">
                                {error.date_fin_cloture}
                            </small>
                        )}
                    </div>
                    <div>
                        <label className="block text-sm c1k3n cu6vl" htmlFor="sale_end_hour">
                        Heure <span className="czr3n">*</span>
                        </label>
                        <input
                            id="sale_end_hour"
                            className="c071z focus:ring-0 caqf9 w-full"
                            type="time"
                            required
                            value={formData.heure_fin_cloture}
                            name='heure_fin_cloture'
                            onChange={handleEventDataChange}
                        />
                        {error.heure_fin_cloture && (
                            <small className="text-red-600 mt-2">
                                {error.heure_fin_cloture}
                            </small>
                        )}
                    </div>

                </div>
            </div>

            <div className="sm:grid-cols-1 my-6 coah6 c4sak">
                <div>
                    <label className="block text-sm mb-2 c1k3n cu6vl" htmlFor="comment">
                    Description de l'événement <span className="czr3n">*</span>
                    </label>
                    <textarea
                        id="comment"
                        className="cn9r8 c071z w-full mb-4"
                        rows={4}
                        placeholder={"Faite une description de l'evenement ici..."}
                        value={formData.description}
                        name='description'
                        onChange={handleEventDataChange}
                        required
                        />

                    {error.description && (
                        <small className="text-red-600 mt-2">
                            {error.description}
                        </small>
                    )}
                </div>
            </div>

            <div className='mb-6'>
                <h4 className="text-gray-800 dark:text-gray-100 font-semibold mb-2">
                Ticket des Ventes
                </h4>
                {ticketsData.map(
                    (billet, index) => billet && (
                    <div key={index} className='mb-6'>
                        <div className="flex items-center justify-between">

                            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-5 mb-3 w-full'>
                                <div>
                                    <label className="block text-sm c1k3n cu6vl" htmlFor={`type`[index]}>
                                    Intitulé <span className="czr3n">*</span>
                                    </label>
                                    <input
                                        id={`type`[index]}
                                        className="c071z focus:ring-0 caqf9 w-full"
                                        type="text"
                                        required
                                        value={ticketsData[index]?.nom}
                                        placeholder={"(ex: VIP)"}
                                        onChange={(e) => handleTicketsDataChange(e, index)}
                                        name={`nom`}
                                    />
                                    {error[`nom${index}`] && (
                                        <small className="text-red-600 mt-2">
                                            {error[`nom${index}`]}
                                        </small>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm c1k3n cu6vl" htmlFor={`price`[index]}>
                                    Prix unitaire <span className="czr3n">*</span>
                                    </label>
                                    <div className="relative">

                                        <input
                                            id={`price`[index]}
                                            className="c071z focus:ring-0 caqf9 w-full"
                                            type="number"
                                            required
                                            value={ticketsData[index]?.prix_unitaire}
                                            placeholder={"(ex: 10 000)"}
                                            onChange={(e) => handleTicketsDataChange(e, index)}
                                            name={`prix_unitaire`}
                                        />
                                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                            <small className="text-gray-500">XOF</small>
                                        </div>
                                    </div>
                                    {error[`prix_unitaire${index}`] && (
                                        <small className="text-red-600 mt-2">
                                            {error[`prix_unitaire${index}`]}
                                        </small>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm c1k3n cu6vl" htmlFor={`quantity`[index]}>
                                        Quantité à vendre <span className="czr3n">*</span>
                                    </label>
                                    <div className="relative">
                                        <input
                                            id={`quantity`[index]}
                                            className="c071z focus:ring-0 caqf9 w-full"
                                            type="number"
                                            required
                                            value={ticketsData[index]?.quantite}
                                            placeholder={"(min: 15)"}
                                            onChange={(e) => handleTicketsDataChange(e, index)}
                                            name={`quantite`}
                                        />
                                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                            <small className="text-gray-500">ticket</small>
                                        </div>
                                    </div>
                                    {error[`quantite${index}`] && (
                                        <small className="text-red-600 mt-2">
                                            {error[`quantite${index}`]}
                                        </small>
                                    )}
                                </div>
                            </div>
                            {index !== 0 && (
                                <i
                                    className="text-2xl text-neutral-400 las la-times-circle hover:text-neutral-900 dark:hover:text-neutral-100 cursor-pointer"
                                    style={{ marginLeft: "8px", marginTop: "5px" }}
                                    onClick={() => removeTicket(index)}
                                />
                            )}
                        </div>
                        
                        <div className="inline-flex items-center">
                            <button
                                onClick={() => toggleCommentField(index)}
                                type="button"
                                className="inline-flex items-center w-full sm:w-auto text-sm text-blue-400 hover:text-blue-500 transition cc0oq cghq3 c0zkc"
                            >
                                
                                
                                {(ticketsData[index]?.comment?.trim() || showComments[index]) ? 
                                    <>
                                        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                                            <path d="M17,17 C17,18.6568542 15.6568542,20 14,20 L9,20 C7.34314575,20 6,18.6568542 6,17 L6,7 L5,7 L5,6 L18,6 L18,7 L17,7 L17,17 Z M9,9 L10,9 L10,16 L9,16 L9,9 Z M11,9 L12,9 L12,16 L11,16 L11,9 Z M13,9 L14,9 L14,16 L13,16 L13,9 Z M7,17 C7,18.1045695 7.8954305,19 9,19 L14,19 C15.1045695,19 16,18.1045695 16,17 L16,7 L7,7 L7,17 Z M13,6 L13,5 L10,5 L10,6 L9,6 L9,5 C9,4.44771525 9.44771525,4 10,4 L13,4 C13.5522847,4 14,4.44771525 14,5 L14,6 L13,6 Z" />
                                        </svg>
                                        Retirer le commentaire
                                    </>
                                : 
                                    <>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            aria-hidden="true"
                                            className="w-4 h-4"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z"
                                                clipRule="evenodd"
                                            ></path>
                                        </svg>
                                        Ajouter un commentaire
                                    </>
                                }
                            </button>
                        </div>
                        {(ticketsData[index]?.comment?.trim() || showComments[index]) && (
                            <>
                                <textarea
                                    id="comment"
                                    className="cn9r8 c071z w-full cgk1f"
                                    rows={2}
                                    placeholder="Saisissez votre commentaire"
                                    onChange={(e) => handleTicketsDataChange(e, index)}
                                    name={`comment`}
                                    value={ticketsData[index]?.comment}
                                    maxLength={500}
                                />
                                {error[`comment${index}`] && (
                                    <small className="text-red-600 mt-2">
                                        {error[`comment${index}`]}
                                    </small>
                                )}
                            </>
                        )}
                    </div>
                ))}

                <div className="flex justify-end mt-10">
                    <button
                        disabled={ticketsData.length >= 5 || isAddButtonDisabled}
                        onClick={addNewTicket}
                        className="mr-4 w-full px-3 sm:ml-3 sm:w-auto text-sm font-medium sm:px-6 border-gray-200 text-gray-800 cc0oq cghq3 cspbm c0zkc cnf4p"
                    >
                        Ajouter
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            aria-hidden="true"
                            className="w-4 h-4"
                        >
                            <path
                                fillRule="evenodd"
                                d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>

            <div className='mt-8 mb-6'>
                <h4 className="text-gray-800 dark:text-gray-100 font-semibold mb-2">
                Téléchargement d'Images
                </h4>
                <div className='sm:grid-cols-2 coah6 c4sak'>
                    
                    <div className='sm:p-8'>
                        <label className="block text-sm mt-2 c1k3n cu6vl">
                        Affiche de l'Événement <span className="czr3n">*</span>
                        </label>
                        
                        <div className="rounded flex border h-52 cghq3 w-full mb-4 mt-4 items-center flex-col justify-center c993f c4ppg cxxjf cyhlg text-center px-5 py-8">
                            {previewImage || formData.affiche ? (
                                <img
                                    className="block w-full rounded-lg h-40 object-contain"
                                    src={previewImage}
                                    alt={formData.affiche}
                                />
                            ) : (
                                <>
                                    <svg
                                        className="inline-flex ca2tk cyq9w cxg65"
                                        width={16}
                                        height={16}
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path d="M8 4c-.3 0-.5.1-.7.3L1.6 10 3 11.4l4-4V16h2V7.4l4 4 1.4-1.4-5.7-5.7C8.5 4.1 8.3 4 8 4ZM1 2h14V0H1v2Z" />
                                    </svg>
                                    <label
                                        htmlFor="afficheUpload"
                                        className="block text-sm text-gray-500 dark:text-gray-400 mb-2 caf78 cursor-pointer"
                                    >
                                    Ajouter une image ici au format (jpg, png).
                                    </label>
                                    
                                    
                                </>
                            )}
                            <input 
                                className="cn8jz" 
                                id="afficheUpload"
                                type="file"
                                onChange={(e) => handleFileChange(e, "affiche")}
                                accept=".jpg, .png" 
                                required
                                name='affiche'
                                />
                        </div>
                        {error.affiche && (
                            <small className="text-red-600 mt-2">
                                {error.affiche}
                            </small>
                        )}
                        <footer className="flex items-center cm4ey">
                            {/* Like button */}
                            <button onClick={() => document.getElementById("afficheUpload").click()} className="flex items-center casia cz0f0 cmpw7 cdqku">
                                <svg
                                className="cmpw7 cdqku cbm9w coqgc"
                                width={16}
                                height={16}
                                viewBox="0 0 16 16"
                                >
                                <path d="M15 15H1a1 1 0 01-1-1V2a1 1 0 011-1h4v2H2v10h12V3h-3V1h4a1 1 0 011 1v12a1 1 0 01-1 1zM9 7h3l-4 4-4-4h3V1h2v6z" />
                                </svg>

                                <div className="text-sm text-gray-500 dark:text-gray-400 ml-2">Télécharger</div>
                            </button>
                        </footer>
                    </div>

                    <div className='sm:p-8'>
                        <label className="block text-sm mt-2 c1k3n cu6vl">
                        Autre image
                        </label>
                        <div className="rounded flex border h-52 cghq3 w-full mb-4 mt-4 items-center flex-col justify-center c993f c4ppg cxxjf cyhlg text-center px-5 py-8">
                            {previewOtherImage || formData.image_lieu_evenement ? (
                                <img
                                    className="block w-full rounded-lg h-40 object-contain"
                                    src={previewOtherImage}
                                    alt={formData.image_lieu_evenement}
                                />
                            ) : (

                                <>
                                    <svg
                                        className="inline-flex ca2tk cyq9w cxg65"
                                        width={16}
                                        height={16}
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path d="M8 4c-.3 0-.5.1-.7.3L1.6 10 3 11.4l4-4V16h2V7.4l4 4 1.4-1.4-5.7-5.7C8.5 4.1 8.3 4 8 4ZM1 2h14V0H1v2Z" />
                                    </svg>
                                    <label
                                        htmlFor="imageLieuUpload"
                                        className="block text-sm text-gray-500 dark:text-gray-400 mb-2 caf78 cursor-pointer"
                                    >
                                    Ajouter une image ici au format (jpg, png).
                                    </label>
                                </>
                            )}
                            <input 
                                className="cn8jz" 
                                id="imageLieuUpload"
                                type="file"
                                onChange={(e) => handleFileChange(e, "image_lieu_evenement")}
                                accept=".jpg, .png" 
                                required
                                name='image_lieu_evenement'
                            />
                        </div>
                        {error.image_lieu_evenement && (
                            <small className="text-red-600 mt-2">
                                {error.image_lieu_evenement}
                            </small>
                        )}
                        <footer className="flex items-center cm4ey">
                            {/* Like button */}
                            <button onClick={() => document.getElementById("imageLieuUpload").click()} className="flex items-center casia cz0f0 cmpw7 cdqku">
                                <svg
                                className="cmpw7 cdqku cbm9w coqgc"
                                width={16}
                                height={16}
                                viewBox="0 0 16 16"
                                >
                                <path d="M15 15H1a1 1 0 01-1-1V2a1 1 0 011-1h4v2H2v10h12V3h-3V1h4a1 1 0 011 1v12a1 1 0 01-1 1zM9 7h3l-4 4-4-4h3V1h2v6z" />
                                </svg>

                                <div className="text-sm text-gray-500 dark:text-gray-400 ml-2">Télécharger</div>
                            </button>
                        </footer>
                    </div>

                </div>
            </div>

            <div className="flex justify-end space-x-5 mb-4">
                <button
                    onClick={refresh}
                    className="nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-base font-medium px-2 py-1 sm:px-4 border bg-white border-neutral-200 text-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-800    "
                >
                    Réinitialiser
                </button>

                <button
                    onClick={handleSubmit}
                    disabled={isSubmitDisabled()}
                    className={`nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-base font-medium px-2 py-1 sm:px-4  ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50`}
                >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin -ml-1 mr-3 h-5 w-5 ml-3"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx={12}
                                    cy={12}
                                    r={10}
                                    stroke="currentColor"
                                    strokeWidth={3}
                                />
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                />
                            </svg>
                            Enregistrement en cours...
                        </>
                    ) : (
                        <>Enregistrer les Modifications</>
                    )}
                </button>
            </div>

            <AddTicketComponent
                visible={addModal}
                onClose={handleOnAddModalClose}
                onConfirm={handleConfirmAddTicket}
                handleTicketsDataChange={handleTicketsDataChange}
                ticketsData={ticketsData}
                setTicketsData={setTicketsData}
            />
        </div>
    )
}
